
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);
// Strategiplan-data – innholdet er den offisielle strategiplanen 2026-2031,
// strukturert for visning som seksjoner på /strategi-sportsplan/strategiplan
export const getstrategiPlanContent = () => ({
  title: t('pg.strategiPlan.ae8017'),
  subtitle: t('pg.strategiPlan.75b6a2'),
  period: '2026 - 2031',
  intro:
    t('pg.strategiPlan.ed735b'),

  whoWeAre: {
    text: [
      t('pg.strategiPlan.d24646'),
      t('pg.strategiPlan.297a48'),
      t('pg.strategiPlan.0297c2'),
    ],
    vision: {
      title: t('pg.strategiPlan.75b6a2'),
      text: t('pg.strategiPlan.606994'),
    },
    purpose:
      t('pg.strategiPlan.8bcd11'),
    values: [
      {
        title: t('pg.strategiPlan.b172f8'),
        text: t('pg.strategiPlan.57563c'),
      },
      {
        title: t('pg.strategiPlan.797bc0'),
        text: t('pg.strategiPlan.21a4c7'),
      },
      {
        title: t('pg.strategiPlan.412824'),
        text: t('pg.strategiPlan.06becb'),
      },
      {
        title: t('pg.strategiPlan.651090'),
        text: t('pg.strategiPlan.5048bb'),
      },
    ],
    culture: [
      t('pg.strategiPlan.582f3a'),
      t('pg.strategiPlan.cc94dd'),
      t('pg.strategiPlan.8de0a0'),
    ],
  },

  whyStrategy: {
    title: t('pg.strategiPlan.41989d'),
    text: [
      t('pg.strategiPlan.bc7cc8'),
      t('pg.strategiPlan.f4e41b'),
      t('pg.strategiPlan.668231'),
    ],
    audience: [
      { who: t('pg.strategiPlan.0b55a8'), what: t('pg.strategiPlan.d01a0e') },
      { who: t('pg.strategiPlan.f4c19b'), what: t('pg.strategiPlan.7932ee') },
      { who: t('pg.strategiPlan.55d57c'), what: t('pg.strategiPlan.2bb0df') },
      { who: t('pg.strategiPlan.1aaddd'), what: t('pg.strategiPlan.387453') },
    ],
  },

  goals: [
    {
      number: 1,
      title: t('pg.strategiPlan.c1d883'),
      intro:
        t('pg.strategiPlan.d0d64f'),
      targets: [
        t('pg.strategiPlan.fb3d7f'),
        t('pg.strategiPlan.1629c4'),
        t('pg.strategiPlan.6187f8'),
        t('pg.strategiPlan.33140b'),
      ],
      subGoals: [
        t('pg.strategiPlan.9fa914'),
        t('pg.strategiPlan.eaf2dd'),
        t('pg.strategiPlan.0d5b82'),
        t('pg.strategiPlan.ee96a9'),
      ],
      metrics: {
        headers: [t('pg.strategiPlan.d54b29'), t('pg.strategiPlan.41fa82'), t('pg.strategiPlan.92aafa'), t('pg.strategiPlan.f59308')],
        rows: [
          [t('pg.strategiPlan.13025f'), '498', '600', '650'],
          [t('pg.strategiPlan.34b48c'), t('pg.strategiPlan.553d71'), '30%', '40%'],
          [t('pg.strategiPlan.56b1c8'), '55', '70', '80'],
        ],
      },
      actions: [
        t('pg.strategiPlan.c4ed68'),
        t('pg.strategiPlan.c33c7a'),
        t('pg.strategiPlan.ccee59'),
        t('pg.strategiPlan.7fc281'),
        t('pg.strategiPlan.5ce5b4'),
        t('pg.strategiPlan.0fd998'),
      ],
    },
    {
      number: 2,
      title: t('pg.strategiPlan.02c3ac'),
      intro:
        t('pg.strategiPlan.f73371'),
      targets: [
        t('pg.strategiPlan.ca4bd4'),
        t('pg.strategiPlan.fc1aef'),
        t('pg.strategiPlan.5258cb'),
        t('pg.strategiPlan.69e04e'),
        t('pg.strategiPlan.36b8ac'),
        t('pg.strategiPlan.d0afb4'),
      ],
      subGoals: [
        t('pg.strategiPlan.db5b93'),
        t('pg.strategiPlan.82bae9'),
        t('pg.strategiPlan.411302'),
        t('pg.strategiPlan.9dedf3'),
      ],
      additionalSections: [
        {
          title: t('pg.strategiPlan.ab8461'),
          text:
            t('pg.strategiPlan.a43573'),
          bullets: [
            t('pg.strategiPlan.304592'),
            t('pg.strategiPlan.447f98'),
            t('pg.strategiPlan.9831c7'),
          ],
        },
        {
          title: t('pg.strategiPlan.2a9808'),
          text:
            t('pg.strategiPlan.02997a'),
          bullets: [
            t('pg.strategiPlan.7e4a1e'),
            t('pg.strategiPlan.d0b76e'),
            t('pg.strategiPlan.6cb3ab'),
            t('pg.strategiPlan.c0241d'),
          ],
        },
        {
          title: t('pg.strategiPlan.55b51f'),
          text: t('pg.strategiPlan.6cdbc1'),
          bullets: [
            t('pg.strategiPlan.c6e58a'),
            t('pg.strategiPlan.92df63'),
            t('pg.strategiPlan.37a003'),
            t('pg.strategiPlan.b6d945'),
            t('pg.strategiPlan.e026f7'),
            t('pg.strategiPlan.6723ce'),
            t('pg.strategiPlan.7c6815'),
          ],
        },
      ],
      metrics: {
        headers: [t('pg.strategiPlan.d54b29'), '2026', '2028', '2031'],
        rows: [
          [t('pg.strategiPlan.3f0f4b'), t('pg.strategiPlan.51368d'), t('pg.strategiPlan.9765f6'), t('pg.strategiPlan.96a694')],
          [t('pg.strategiPlan.d90629'), t('pg.strategiPlan.51368d'), '60%', '80%'],
          [t('pg.strategiPlan.998eaf'), '–', t('pg.strategiPlan.a3ec70'), t('pg.strategiPlan.699f22')],
          [t('pg.strategiPlan.728582'), t('pg.strategiPlan.bbe2ee'), 'Ja', t('pg.strategiPlan.2b53e4')],
          [t('pg.strategiPlan.3c7bfb'), '88', '110', '120'],
        ],
      },
      actions: [
        t('pg.strategiPlan.48dae1'),
        t('pg.strategiPlan.2c007b'),
        t('pg.strategiPlan.ed8a3b'),
        t('pg.strategiPlan.968ee9'),
        t('pg.strategiPlan.8457fb'),
        t('pg.strategiPlan.2384a9'),
        t('pg.strategiPlan.0a178b'),
      ],
    },
    {
      number: 3,
      title: t('pg.strategiPlan.47369a'),
      intro:
        t('pg.strategiPlan.c76e2d'),
      targets: [
        t('pg.strategiPlan.720ebd'),
        t('pg.strategiPlan.cf0db9'),
        t('pg.strategiPlan.afa203'),
        t('pg.strategiPlan.76dc42'),
      ],
      subGoals: [
        t('pg.strategiPlan.60a6cc'),
        t('pg.strategiPlan.f6fb6e'),
        t('pg.strategiPlan.f398a6'),
        t('pg.strategiPlan.1cf0b4'),
        t('pg.strategiPlan.da7212'),
        t('pg.strategiPlan.75b1e2'),
      ],
      metrics: {
        headers: [t('pg.strategiPlan.d54b29'), '2026', '2028', '2031'],
        rows: [
          [t('pg.strategiPlan.19a415'), '1', '3', '5+'],
          [t('pg.strategiPlan.9084ef'), t('pg.strategiPlan.51368d'), '500 000', t('pg.strategiPlan.233b13')],
          [
            t('pg.strategiPlan.858b23'),
            t('pg.strategiPlan.468ac9'),
            t('pg.strategiPlan.a5c592'),
            t('pg.strategiPlan.4eaefc'),
          ],
          [t('pg.strategiPlan.c27d77'), 'Ja', t('pg.strategiPlan.b2826e'), t('pg.strategiPlan.b2826e')],
        ],
      },
      actions: [
        t('pg.strategiPlan.d4f8f9'),
        t('pg.strategiPlan.0ecf79'),
        t('pg.strategiPlan.cecd0c'),
        t('pg.strategiPlan.eb1f4f'),
      ],
    },
  ],

  closing: {
    title: t('pg.strategiPlan.3ea34b'),
    text: [
      t('pg.strategiPlan.44d570'),
      t('pg.strategiPlan.d594e5'),
      t('pg.strategiPlan.62fa87'),
      t('pg.strategiPlan.0d3e97'),
      t('pg.strategiPlan.b6b7b6'),
    ],
    signedAt: t('pg.strategiPlan.72d76a'),
    signatures: [
      t('pg.strategiPlan.be9911'),
      t('pg.strategiPlan.def5b0'),
      t('pg.strategiPlan.01fe21'),
      t('pg.strategiPlan.ca6970'),
      t('pg.strategiPlan.35013a'),
      t('pg.strategiPlan.ec07a9'),
      t('pg.strategiPlan.2dd0ba'),
    ],
  },
});
